export const COLLECTIVE_TITLE = 'My Collective';
